export default class userpermission {
    public Deleted = false
    public InsertedDate = "0001-01-01T00:00:00"
    public PermissionId = 0
    public UserId = 0
    public UserPermissionId = 0
}